/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { SessionDto } from './session-dto';
 /**
 *
 *
 * @export
 * @interface SessionPaginatedResponseDto
 */
export interface SessionPaginatedResponseDto {

    /**
     * @type {Array<SessionDto>}
     * @memberof SessionPaginatedResponseDto
     */
    data: Array<SessionDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof SessionPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
